export default "assets/images/icons/marker-e6f21840.svg";